import { config } from "@/config";

// Riders asked to read the contract before paying the caução (Mário
// 2026-10-15): the landing page carries it, so the flow points there.
export function ContractNote() {
  const label = config.contractUrl
    .replace(/^https?:\/\/(www\.)?/, "")
    .replace(/\/$/, "");
  return (
    <p className="lpc-contract-note" data-testid="contract-link-note">
      Para ler o contrato, acesse nossa página:{" "}
      <a
        data-testid="contract-link"
        href={config.contractUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </a>
    </p>
  );
}
